/**
 * @zag/planning/common
 *
 * Shared types, models, and utilities for planning domain.
 * This library contains:
 * - ArkType model schemas (for API validation)
 * - Validation types (for draft state operations)
 * - Assignment and Person types (shared between UI and API)
 * - Shift overlap utilities (pure functions for time calculations)
 */

export * from './models';
export * from './validation';
export { isSkillConflictType } from './validation/conflict.types';
export * from './types';
export * from './utils';
export * from './lib/planning.features';
